// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const actions = {
  fetchConfigMicrosoftEntraId(_, payload) {
    return ApiService.fetchConfigMicrosoftEntraId(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
  updateConfigMicrosoftEntraId(_, payload) {
    return ApiService.updateConfigMicrosoftEntraId(payload)
      .then((res) => {
        return res.data
      })
      .catch((error) => {
        throw error
      })
  },
}
